import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface GoalsOutstandingMetricState {
  data: any;
  readOnly?: boolean;
  setSelectedData: (data: any[] | null) => void;
  setDataHeaders: (data: any[] | null) => void;
  active?: boolean;
  onHandleClick?: any;
}

export const GoalsOutstandingMetric = ({
  data,
  readOnly = true,
  setSelectedData,
  setDataHeaders,
  active,
  onHandleClick,
}: GoalsOutstandingMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [outstanding, setOutstanding] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", width: "300px" },
    { label: "Goal ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "subject.name", width: "200px" },
    { label: "Tasks Completed", key: "taskCount", width: "120px" },
    { label: "Created", key: "created_at_formatted", width: "100px" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      let outstanding = goals?.filter((g: any) => !g.completed_at);
      outstanding = outstanding?.map((g: any) => {
        return { ...g, taskCount: `${g.completed_tasks}/${g.total_tasks}` };
      });
      setOutstanding(outstanding);
    }
    setIsLoading(false);
  }, [data]);

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(outstanding || null);
    } else {
      setSelectedData(null);
    }

    setDataHeaders(tableHeaders);
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={"Goals Outstanding"} total={outstanding?.length} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Goals Outstanding"}
        total={outstanding?.length}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
